<template>
    <div v-if="text"
        class="absolute group-hover:block bg-black text-white p-3 rounded-md -top-10 left-0 z-50 whitespace-nowrap text-sm opacity-75">
        {{ text }}
        <div class="w-4 h-4 absolute -bottom-2 bg-black rotate-45"></div>
    </div>
</template>

<script setup lang="ts">
defineProps({
    text: String
})
</script>
